/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {combineReducers} from "@reduxjs/toolkit";
import {cameraSlice, lidarSlice, radarSlice, ultrasonicSlice, vehicleProgramSlice} from "./slices";


export const wizardReducers = combineReducers({
  [cameraSlice.name]: cameraSlice.reducer,
  [radarSlice.name]: radarSlice.reducer,
  [vehicleProgramSlice.name]: vehicleProgramSlice.reducer,
  [ultrasonicSlice.name] : ultrasonicSlice.reducer,
  [lidarSlice.name] : lidarSlice.reducer
})

export default wizardReducers